import styled from 'styled-components';

const Svg = styled.svg`
  ${({ theme: { spacing } }) => `
    width: ${spacing(5)};
    height: ${spacing(5)};
  `}
`;

type Props = {
  color?: string;
  className?: string;
};

const MoreVertical = ({ className = '', color = 'currentColor' }: Props) => (
  <Svg className={className} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="5" r="1.5" fill={color} />
    <circle cx="12" cy="12" r="1.5" fill={color} />
    <circle cx="12" cy="19" r="1.5" fill={color} />
  </Svg>
);

export default MoreVertical;
